import { TokenService } from '@/services/storage.service'
import AccountInventoryService from '@/services/accountinventory.service.js'
import OppregAdminService from '@/services/oppregadmin.service.js'
import { UserService } from '@/services/user.service'
// import Roles from './role'
import Vue from 'vue'

export const generateRegistrationID = (oppId, title) => {
  return oppId && title ? `${oppId}-${title.replace(/[|&;$%@"<>()+,\s]/g, '-')}` : ''
}

export const lazyLoadComponent = (view) => {
  return () => import(`@/views/${view}.vue`)
}

export const getCountries = () => {
  let countries = [
    // Countries under NCE Region
    { region: 'NCE', country: 'Albania', code: 'al', regcode: '' },
    { region: 'NCE', country: 'Austria', code: 'at', regcode: '' },
    { region: 'NCE', country: 'Belarus', code: 'by', regcode: '' },
    { region: 'NCE', country: 'Bosnia', code: 'ba', regcode: '' },
    { region: 'NCE', country: 'Herzegovina', code: 'ba', regcode: '' },
    { region: 'NCE', country: 'Bulgaria', code: 'bg', regcode: '' },
    { region: 'NCE', country: 'Croatia', code: 'hr', regcode: '' },
    { region: 'NCE', country: 'Cyprus', code: 'cy', regcode: '' },
    { region: 'NCE', country: 'Czech Republic', code: 'cz', regcode: '' },
    { region: 'NCE', country: 'Denmark', code: 'dk', regcode: '' },
    { region: 'NCE', country: 'Estonia', code: 'ee', regcode: '' },
    { region: 'NCE', country: 'Finland', code: 'fi', regcode: '' },
    { region: 'NCE', country: 'Germany', code: 'de', regcode: '' },
    { region: 'NCE', country: 'Greece', code: 'gr', regcode: '' },
    { region: 'NCE', country: 'Hungary', code: 'hu', regcode: '' },
    { region: 'NCE', country: 'Iceland', code: 'is', regcode: '' },
    { region: 'NCE', country: 'Kosovo', code: 'xk', regcode: '' },
    { region: 'NCE', country: 'Latvia', code: 'lv', regcode: '' },
    { region: 'NCE', country: 'Liechtenstein', code: 'li', regcode: '' },
    { region: 'NCE', country: 'Lithuania', code: 'lt', regcode: '' },
    { region: 'NCE', country: 'Macedonia', code: 'mk', regcode: '' },
    { region: 'NCE', country: 'Moldavia', code: '', regcode: '' },
    { region: 'NCE', country: 'Montenegro', code: 'me', regcode: '' },
    { region: 'NCE', country: 'The Netherlands', code: '', regcode: '' },
    { region: 'NCE', country: 'Norway', code: 'no', regcode: '' },
    { region: 'NCE', country: 'Poland', code: 'pl', regcode: '' },
    { region: 'NCE', country: 'Romania', code: 'ro', regcode: '' },
    { region: 'NCE', country: 'Russian Federation', code: 'ru', regcode: '' },
    { region: 'NCE', country: 'Serbia', code: 'rs', regcode: '' },
    { region: 'NCE', country: 'Slovakia', code: 'sk', regcode: '' },
    { region: 'NCE', country: 'Sweden', code: 'se', regcode: '' },
    { region: 'NCE', country: 'Switzerland', code: 'ch', regcode: '' },
    { region: 'NCE', country: 'Turkey', code: 'tr', regcode: '' },
    { region: 'NCE', country: 'Ukraine', code: 'ua', regcode: '' },

    // Countries under SE (South Europe) Region
    { region: 'SE', country: 'Italy', code: 'it', regcode: '' },
    { region: 'SE', country: 'Malta', code: 'mt', regcode: '' },
    { region: 'SE', country: 'Portugal', code: 'pt', regcode: '' },
    { region: 'SE', country: 'Spain', code: 'es', regcode: '' },
    { region: 'SE', country: 'France', code: 'fr', regcode: '' },
    { region: 'SE', country: 'Belgium', code: 'be', regcode: '' },
    { region: 'SE', country: 'Luxembourg', code: 'lu', regcode: '' },

    // Countries under ANZ Region
    { region: 'ANZ', country: 'Australia', code: 'au', regcode: '' },
    { region: 'ANZ', country: 'New Zealand', code: 'nz', regcode: '' },
    { region: 'ANZ', country: 'Fiji', code: 'fj', regcode: '' },

    // Countries under Asia Region
    { region: 'Asia', country: 'China', code: 'cn', regcode: '' },
    { region: 'Asia', country: 'Hong Kong', code: 'hk', regcode: '' },
    { region: 'Asia', country: 'Indonesia', code: 'id', regcode: '' },
    { region: 'Asia', country: 'India', code: 'in', regcode: '' },
    { region: 'Asia', country: 'Japan', code: 'jp', regcode: '' },
    { region: 'Asia', country: 'Korea', code: 'kr', regcode: '' },
    { region: 'Asia', country: 'Malaysia', code: 'my', regcode: '' },
    { region: 'Asia', country: 'Philippines', code: 'ph', regcode: '' },
    { region: 'Asia', country: 'Singapore', code: 'sg', regcode: '' },
    { region: 'Asia', country: 'Thailand', code: 'th', regcode: '' },
    { region: 'Asia', country: 'Taiwan', code: 'tw', regcode: '' },
    { region: 'Asia', country: 'Vietnam', code: 'vn', regcode: '' },
    { region: 'Asia', country: 'Middle East', code: '', regcode: '' },

    // MIDDLE EAST COUNTRIES
    { region: 'Asia', country: 'Africa', code: '', regcode: '' },

    // Countries under UKIIMEA Region
    { region: 'UKIIMEA', country: 'Afghanistan', code: 'af', regcode: '' },
    { region: 'UKIIMEA', country: 'Algeria', code: 'dz', regcode: '' },
    { region: 'UKIIMEA', country: 'Angola', code: 'ao', regcode: '' },
    { region: 'UKIIMEA', country: 'Bahrain', code: 'bh', regcode: '' },
    { region: 'UKIIMEA', country: 'Botswana', code: 'bw', regcode: '' },
    { region: 'UKIIMEA', country: 'Egypt', code: 'eg', regcode: '' },
    { region: 'UKIIMEA', country: 'Ethiopia', code: 'et', regcode: '' },
    { region: 'UKIIMEA', country: 'Ghana', code: 'gh', regcode: '' },
    { region: 'UKIIMEA', country: 'Iraq', code: 'iq', regcode: '' },
    { region: 'UKIIMEA', country: 'Ireland', code: 'ie', regcode: '' },
    { region: 'UKIIMEA', country: 'Israel', code: 'il', regcode: '' },
    { region: 'UKIIMEA', country: 'Jordan', code: 'jo', regcode: '' },
    { region: 'UKIIMEA', country: 'Kazakhstan', code: 'kz', regcode: '' },
    { region: 'UKIIMEA', country: 'Kenya', code: 'ke', regcode: '' },
    { region: 'UKIIMEA', country: 'Kuwait', code: 'kw', regcode: '' },
    { region: 'UKIIMEA', country: 'Lebanon', code: 'lb', regcode: '' },
    { region: 'UKIIMEA', country: 'Lesotho', code: 'ls', regcode: '' },
    { region: 'UKIIMEA', country: 'Libya', code: 'ly', regcode: '' },
    { region: 'UKIIMEA', country: 'Madagascar', code: 'mg', regcode: '' },
    { region: 'UKIIMEA', country: 'Malawi', code: 'mw', regcode: '' },
    { region: 'UKIIMEA', country: 'Mauritius', code: 'mu', regcode: '' },
    { region: 'UKIIMEA', country: 'Morocco', code: 'ma', regcode: '' },
    { region: 'UKIIMEA', country: 'Mozambique', code: 'mz', regcode: '' },
    { region: 'UKIIMEA', country: 'Namibia', code: 'na', regcode: '' },
    { region: 'UKIIMEA', country: 'Nigeria', code: 'ng', regcode: '' },
    { region: 'UKIIMEA', country: 'Oman', code: 'om', regcode: '' },
    { region: 'UKIIMEA', country: 'Qatar', code: 'qa', regcode: '' },
    { region: 'UKIIMEA', country: 'Rwanda', code: 'rw', regcode: '' },
    { region: 'UKIIMEA', country: 'Saudi Arabia', code: 'sa', regcode: '' },
    { region: 'UKIIMEA', country: 'Senegal', code: 'sn', regcode: '' },
    { region: 'UKIIMEA', country: 'Seychelles', code: 'sc', regcode: '' },
    { region: 'UKIIMEA', country: 'Sierra Leone', code: 'sl', regcode: '' },
    { region: 'UKIIMEA', country: 'South Africa', code: 'za', regcode: '' },
    { region: 'UKIIMEA', country: 'Tanzania', code: 'tz', regcode: '' },
    { region: 'UKIIMEA', country: 'Tunisia', code: 'tn', regcode: '' },
    { region: 'UKIIMEA', country: 'United Arab Emirates', code: 'ae', regcode: '' },
    { region: 'UKIIMEA', country: 'United Kingdom', code: 'uk', regcode: '' },
    { region: 'UKIIMEA', country: 'Zambia', code: 'zm', regcode: '' },
    { region: 'UKIIMEA', country: 'Zimbabwe', code: 'zw', regcode: '' },

    // Countries unde Americas
    { region: 'AMS', country: 'Argentina', code: 'ar', regcode: '' },
    { region: 'AMS', country: 'Brazil', code: 'br', regcode: '' },
    { region: 'AMS', country: 'Canada', code: 'ca', regcode: '' },
    { region: 'AMS', country: 'Chile', code: 'cl', regcode: '' },
    { region: 'AMS', country: 'Columbia', code: '', regcode: '' },
    { region: 'AMS', country: 'Costa Rica', code: 'cr', regcode: '' },
    { region: 'AMS', country: 'Ecuador', code: 'ec', regcode: '' },
    { region: 'AMS', country: 'Honduras', code: 'hn', regcode: '' },
    { region: 'AMS', country: 'Mexico', code: 'mx', regcode: '' },
    { region: 'AMS', country: 'Panama', code: 'pa', regcode: '' },
    { region: 'AMS', country: 'Peru', code: 'pe', regcode: '' },
    { region: 'AMS', country: 'Puerto Rico', code: 'pr', regcode: '' },
    { region: 'AMS', country: 'Venezuela', code: 've', regcode: '' },
    { region: 'AMS', country: 'United States of America', code: 'us', regcode: '' }

  ]

  return countries.sort((a, b) => {
    const countryA = a.country.toUpperCase(); 
    const countryB = b.country.toUpperCase();
    if (countryA < countryB) {
      return -1;
    }
    if (countryA > countryB) {
      return 1;
    }
    // names must be equal
    return 0
  })
}

export const parseToken = (token) => {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  return JSON.parse(window.atob(base64))
}

export const isObjectEquivalent = (a, b) => {
  // Create arrays of property names
  var aProps = Object.getOwnPropertyNames(a)
  var bProps = Object.getOwnPropertyNames(b)

  // If number of properties is different,
  // objects are not equivalent
  if (aProps.length !== bProps.length) {
    return false
  }

  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i]

    // If values of same property are not equal,
    // objects are not equivalent
    if (a[propName] !== b[propName]) {
      return false
    }
  }

  // If we made it this far, objects
  // are considered equivalent
  return true
}

export const isGroupNotEqual = (curUsergroups, tokenGroups) => {
  return curUsergroups.some(group => {
    return !tokenGroups.includes(group)
  })
}

export const initRefreshData = () => {
  if (window.refreshInterval === undefined) {
    window.refreshInterval = setInterval(() => {
    if (UserService.validateToken()) {
      let accountPromData = AccountInventoryService.refreshData()
      let oppregPromData = OppregAdminService.refreshData()
      Promise.all([accountPromData, oppregPromData]).then(data => {
        console.log('Data synced successfully.')
        vm.$store.commit('admin/accountInventory/setInitData', data[0])
        vm.$store.commit('admin/oppregAdmin/setInitData', data[1].oppreg_data)
        vm.$store.commit('setLastSyncDateTime', window.moment().format('M/D/Y H:mm:ss'), { root: true })
      })
    }
  }, process.env.VUE_APP_REFRESH_MS)
  }
}

export const IsJsonString = (str) => {
  try {
    let jsonStr = JSON.parse(str)
    return jsonStr.length || typeof jsonStr === 'object'
  } catch (e) {
    return false
  }
}
// export const isAdmin = () => {
//   let token = TokenService.getToken()
//   if (token) {
//     let tokenInfo = parseToken(token)
//     return tokenInfo['cognito:groups'].includes(Roles.Admin)
//   }
//   return false
// }

export const getUserGroup = () => {
  let token = TokenService.getToken()
  if (token) {
    let tokenInfo = parseToken(token)
    return tokenInfo['cognito:groups']
  }
  return false
}

export const checkRoutePermission = (path) => {
  // check the url path if logged-in user have access.
  // console.log('checkRoutePermission: ', path)
  let curUser = TokenService.getCurrentUser()
  let hasAccess = false
  if (curUser) {
    let abilities = Object.keys(curUser.routes[0].abilities)
    let access = abilities.filter(ability => { return path.includes(ability) })
    if (access.length >= 1) {
      hasAccess = true
    }
  }
  return hasAccess
}
export const checkSubRoutePermission = (path) => {
  let curUser = TokenService.getCurrentUser()
  let hasAccess = false
  const subRoutes = curUser.routes[0].sub_routes
  if (curUser) {
    for (const [key, routes] of Object.entries(subRoutes)) {
      if (path.includes(key) && routes.some(route => path.includes(route))) {
        return true;
      }
    }
  }
  return hasAccess
}
export const checkActionPermission = (action, modules) => {
  let curUser = TokenService.getCurrentUser()
  let hasAccess = false
  if (curUser) {
    let fieldPermissions = curUser.routes[0].fieldPermissions
    let validActions = Object.keys(curUser.routes[0].fieldPermissions)
    hasAccess =  validActions.includes(action) && fieldPermissions[action].includes(modules)
  }
  console.log('checkActionPermission: ', action, modules, hasAccess)
  return hasAccess
}

export const convertUTCToLocal = (utcDate) => {

  let stillUtc = moment.utc(utcDate).toDate();
  let localDateTime = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss');

  return localDateTime
}

export const highlightLogRecordText = (log) => {
  let highlightedLogRecord = { ...log }
  let objFromJson = JSON.parse(log.Change_From)
  let objToJson = JSON.parse(log.Change_To)

  for (const key in objFromJson) {
    if (objToJson !== null && objToJson.hasOwnProperty(key)) {
      objFromJson[key] = "<em style='color:red'>" + objFromJson[key] + '</em>'
      objToJson[key] = "<em style='color:green'>" + objToJson[key] + '</em>'
    }
  }

  highlightedLogRecord.Change_From = objFromJson
  highlightedLogRecord.Change_To = objToJson
  return highlightedLogRecord
}

export const getCountryCodes = () => {
  return ['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW']
}

const awsExtractFormatMapping = [
  { label: 'DXC Opportunity Region', field: 'Customer_Region', defaultValue: '' },
  { label: 'DXC Opportunity Company Name', field: 'Customer_Name', defaultValue: '' },
  { label: 'DXC Opportunity Owner Full Name', field: 'Contact_FullName', defaultValue: '' },
  { label: 'DXC Opportunity Owner Title', field: '', defaultValue: 'N/A' },
  { label: 'DXC Opportunity Owner Phone', field: 'Contact_Phone', defaultValue: '' },
  { label: 'DXC Opportunity Owner Email', field: 'Contact_Email', defaultValue: 'N/A' },
  { label: 'AWS Account ID', field: '', defaultValue: '' },
  { label: 'Partner Project Title', field: 'OppReg_Id', defaultValue: '' },
  { label: 'Project Description', field: 'Workload_Description', defaultValue: '' },
  { label: 'AWS Project Details', field: '', defaultValue: '' },
  { label: 'Expected Monthly AWS Revenue', field: 'Projected_Monthly_Spend', defaultValue: '' },
  { label: 'AWS Industry Vertical', field: 'IndustryVertical', defaultValue: 'Other' },
  //{ label: 'DXC Industry', field: '', defaultValue: '' }, // check
  { label: 'Customer Country', field: 'Country', defaultValue: '' },
  { label: 'Customer State/Province', field: 'Customer_State', defaultValue: '' },
  { label: 'Customer Street Address', field: 'Customer_Address', defaultValue: '' },
  { label: 'Customer City', field: 'Customer_City', defaultValue: '' },
  { label: 'Customer Postal Code', field: 'Customer_PC', defaultValue: '' },
  { label: 'Customer Primary Website URL', field: 'Customer_URL', defaultValue: '' },
  { label: 'AWS Use Case', field: '', defaultValue: 'Migration / Database Migration' },
  { label: 'AWS Sub Use Case', field: '', defaultValue: '' },
  { label: 'Target Close Date', field: 'SignDate', defaultValue: '' },
  { label: 'Partner Primary Need from AWS', field: '', defaultValue: '' },
  { label: 'Is this for resell?', field: 'DXC_Managed_Services', defaultValue: '' },
  { label: 'Competitive Tracking', field: '', defaultValue: '' },
  { label: 'Other Competitors', field: '', defaultValue: '' },
  { label: 'Primary DXC Sales Contact', field: '', defaultValue: 'Shasta Kalin' },
  { label: 'AWS Field Engagement', field: '', defaultValue: '' },
  { label: 'Requesting MAP credits for this opportunity?', field: '', defaultValue: 'No' },
  { label: 'Contract Vehicle', field: '', defaultValue: '' },
  { label: 'Is this for Marketplace?', field: '', defaultValue: 'No' },
  { label: 'Marketing Development Funded', field: '', defaultValue: '' },
  { label: 'RBAC/Credentials', field: '', defaultValue: 'No' },
  { label: 'Currently on AWS', field: '', defaultValue: '' },
  { label: 'Eligibility', field: '', defaultValue: '' },
  { label: 'Workloads net-new to AWS and NOT under DXC mgmt?', field: '', defaultValue: '' },
  { label: 'DXC SaaS-delivered-solution?', field: 'SaaS', defaultValue: '' },
  { label: 'Is result of an RFI/RFP', field: 'RFI_RFP', defaultValue: '' },
  { label: 'Attestation', field: 'PPA_Attestation', defaultValue: '' },
  { label: 'AWS Status', field: 'Workload_Status', defaultValue: '' },
  { label: 'Approved Tier', field: 'Workload_Status', defaultValue: '' },
  { label: 'Date Approved', field: '', defaultValue: '' },
  { label: 'Opportunity Status', field: '', defaultValue: '' },
  { label: 'AWS Sales Rep Name', field: 'AWS_SalesRep_Name', defaultValue: '' },
  { label: 'AWS Sales Rep Email', field: 'AWS_SalesRep_eMail', defaultValue: '' },
  { label: 'SFDC Status', field: 'Workload_Status', defaultValue: '' },
  { label: 'Notes', field: 'AWS_Notes', defaultValue: '' },
  { label: 'Creator Name', field: 'Creator Name', defaultValue: '' },
  { label: 'Creator Email', field: 'Requestor_Email', defaultValue: '' },
  { label: 'Created Time', field: '', defaultValue: ' ' },
  { label: 'Last Modified Name', field: '', defaultValue: ' ' },
  { label: 'Last Modified Email', field: '', defaultValue: ' ' },
  { label: 'Last Modified Time', field: '', defaultValue: ' ' },
  { label: 'WL_Q1A', field: 'WL_Q1A', defaultValue: '' },
  { label: 'WL_Q2A', field: 'WL_Q2A', defaultValue: '' },
  { label: 'WL_Q3A', field: 'WL_Q3A', defaultValue: '' },
  { label: 'WL_Q4A', field: 'WL_Q4A', defaultValue: '' },
  { label: 'WL_Q5A', field: 'WL_Q5A', defaultValue: '' },
  { label: 'WL_Q6A', field: 'WL_Q6A', defaultValue: '' },
  { label: 'WL_Q7A', field: 'WL_Q7A', defaultValue: '' },
  { label: 'WL_Q8A', field: 'WL_Q8A', defaultValue: '' },
  { label: 'WL_Q9A', field: 'WL_Q9A', defaultValue: '' },
  { label: 'WL_Q10A', field: 'WL_Q10A', defaultValue: '' },
  { label: 'Attested By', field: 'Attested_By', defaultValue: '' },
  { label: 'DXC Services', field: 'DXC_Services', defaultValue: '' },
  { label: 'Projected Monthly Spend', field: 'Projected_Monthly_Spend', defaultValue: '' }
]

const awReportMapping = [
  { label: 'DXC Opportunity Region', field: 'DXC_Opportunity_Region', defaultValue: '' },
  { label: 'DXC Opportunity Company Name', field: 'DXC_Opportunity_Company_Name', defaultValue: '' },
  { label: 'Partner Project Title', field: 'Partner_Project_Title', defaultValue: '' },
  { label: 'Project Description', field: 'Project_Description', defaultValue: '' },
  { label: 'Expected Monthly AWS Revenue', field: 'Expected_Monthly_AWS_Revenue', defaultValue: '' },
  { label: 'DXC Industry', field: 'DXC_Industry', defaultValue: '' },
  { label: 'Customer Country', field: 'Customer_Country', defaultValue: '' },
  { label: 'Customer State', field: 'Customer_State', defaultValue: '' }, 
  { label: 'Customer Street Address', field: 'Customer_Street_Address', defaultValue: '' }, 
  { label: 'Customer City', field: 'Customer_City', defaultValue: '' },
  { label: 'Customer Postal Code', field: 'Customer_Postal_Code', defaultValue: '' },
  { label: 'Customer Primary Website URL', field: 'Customer_Primary_Website_URL', defaultValue: '' },
  { label: 'Target Close Date', field: 'Target_Close_Date', defaultValue: '' },
  { label: 'Saas?', field: 'Saas', defaultValue: '' },
  { label: 'Attestation', field:'Attestation', defaultValue: '' },
  { label: 'Approved Tier', field: 'Approved_Tier', defaultValue: '' },
  { label: 'Date Approved', field: 'Date_Approved', defaultValue: '' },
  { label: 'SFDC Status', field: 'SFDC_Status', defaultValue: '' },
  { label: 'Notes', field: 'Notes', defaultValue: '' },
  { label: 'Creator Name', field: 'Creator_Name', defaultValue: '' },
  { label: 'Creator Email', field: 'Creator_Email', defaultValue: '' },
  { label: 'Date Created', field: 'Date_Created', defaultValue: '' },
]

export const getAwsReportData = (inputData) => {
  let outputData = []
  for (let index = 0; index < inputData.length; index++) {
    let outputRecord = {}
    const record = inputData[index]
    awReportMapping.forEach(data => {
      if (record.hasOwnProperty(data.field)) {
        outputRecord[data.label] = record[data.field]
      } else {
        outputRecord[data.label] = data.defaultValue
      }
    })
    outputData.push(outputRecord)
  }
  return outputData
}


export const getAwsExtractData = (inputData) => {
  let outputData = []
  for (let index = 0; index < inputData.length; index++) {
    let outputRecord = {}
    const record = inputData[index]
    awsExtractFormatMapping.forEach(data => {
      if (record.hasOwnProperty(data.field)) {
        outputRecord[data.label] = record[data.field]
      } else {
        outputRecord[data.label] = data.defaultValue
      }
    })
    outputData.push(outputRecord)
  }
  return outputData
}

const awsApnExtract = [
  { label: 'Customer Company Name', field: 'Customer_Company_Name', defaultValue: '', apnField: '' },
  { label: 'Partner Project Title', field: 'Partner_Project_Title', defaultValue: '', apnField: 'partnerCrmUniqueIdentifier' },
  { label: 'Project Description/Business Need', field: 'Project_Description', defaultValue: '', apnField: 'partnerProjectTitle' },
  { label: 'Expected Monthly AWS Revenue', field: 'Expected_Monthly_AWS_Revenue', defaultValue: '' },
  { label: 'Industry Vertical ', field: 'Industry_Vertical', defaultValue: '', apnField: '' },
  { label: 'Country', field: 'Country', defaultValue: '', apnField: 'country' },
  { label: 'Postal Code', field: 'Postal_Code', defaultValue: '', apnField: 'postalCode' },
  { label: 'Website', field: 'Website', defaultValue: '', apnField: 'publicReferenceUrl' },
  { label: 'Use Case', field: 'Use_Case', defaultValue: 'Migration / Database Migration', apnField: 'useCase' },
  { label: 'Target Close Date', field: 'Target_Close_Date', defaultValue: '', apnField: 'targetCloseDate' },
  { label: 'Partner Primary Need from AWS', field: 'Partner_Primary_Need_from_AWS', defaultValue: '', apnField: 'partnerPrimaryNeedFromAws' },
  { label: 'Customer First Name', field: 'Customer_First_Name', defaultValue: '', apnField: 'customerFirstName' },
  { label: 'Customer Last Name', field: 'Customer_Last_Name', defaultValue: '', apnField: 'customerLastName' },
  { label: 'Customer Title', field: 'Customer_Title', defaultValue: '', apnField: 'customerTitle' },
  { label: 'Customer Phone', field: 'Customer_Phone', defaultValue: '', apnField: 'customerPhone' },
  { label: 'Customer Email', field: 'Customer_Email', defaultValue: '', apnField: 'customerEmail' },
  { label: 'AWS Account ID', field: 'AWS_Account_ID', defaultValue: '', apnField: 'awsAccountId' },
  { label: 'Additional Comments', field: 'Additional_Comments', defaultValue: '', apnField: 'additionalComments' },
  { label: 'Industry Other', field: 'Other_Industry', defaultValue: '', apnField: '' },
  { label: 'State/Province', field: 'State_Province', defaultValue: '', apnField: 'state' },
  { label: 'Street Address', field: 'Street_Address', defaultValue: '', apnField: 'streetAdress' },
  { label: 'City', field: 'City', defaultValue: '', apnField: 'city' },
  { label: 'Sub Use Case', field: 'Sub_Use_Case', defaultValue: '', apnField: 'subUseCase' },
  { label: 'Is this for Resell?', field: 'Is_this_for_Resell', defaultValue: '', apnField: 'isThisForResell' },
  { label: 'Competitive Tracking', field: 'Competitive_Tracking', defaultValue: '', apnField: 'competitiveTracking' },
  { label: 'Other Competitors', field: 'Other_Competitors', defaultValue: '', apnField: '' },
  { label: 'Campaign Name', field: 'Campaign_Name', defaultValue: '', apnField: 'campaignName' },
  { label: 'Contract Vehicle', field: 'Contract_Vehicle', defaultValue: '', apnField: 'contractVehicle' },
  { label: 'Is this for Marketplace?', field: 'Is_this_for_Marketplace', defaultValue: '', apnField: 'isThisForMarketplace' },
  { label: 'Marketing Development Funded ?', field: 'Marketing_Development_Funded', defaultValue: '', apnField: 'isMarketingDevelopmentFunded' },
  { label: 'Did an AWS Account Rep for this customer support you in this opportunity?', field: 'Did_an_AWS_Account_Rep_for_this_opportunity', defaultValue: '', apnField: '' },
  { label: 'Primary Sales Contact First Name', field: 'Primary_Sales_Contact_First_Name', defaultValue: '', apnField: 'primaryContactFirstName' },
  { label: 'Primary Sales Contact Last Name?', field: 'Primary_Sales_Contact_Last_Name', defaultValue: '', apnField: 'primaryContactLastName' },
  { label: 'Primary Sales Contact Phone', field: 'Primary_Sales_Contact_Phone', defaultValue: '', apnField: 'primaryContactPhone' },
  { label: 'Primary Sales Contact Email', field: 'Primary_Sales_Contact_Email', defaultValue: '', apnField: 'primaryContactEmail' },
  { label: 'Primary Contact Title', field: 'Primary_Sales_Contact_Title', defaultValue: '', apnField: '' },
  { label: 'Does this opportunity include managed services?', field: 'Does_this_opportunity_include_managed_services', defaultValue: '', apnField: '' }

]

export const getAwsAPNExtractData = (inputData, toAPN) => {
  console.log('-------- HELPER: getAwsAPNExtractData ---------')
  let outputData = []
  for (let index = 0; index < inputData.length; index++) {
    let outputRecord = {}
    const record = inputData[index]
    awsApnExtract.forEach(data => {
      let label = toAPN == 1 ? data.apnField : data.label
      let value = record[data.field] == 'None' ? data.defaultValue : record[data.field]
      value = record[data.field] == null ? data.defaultValue : value

      if (label) {
        outputRecord[label] = record.hasOwnProperty(data.field) == true ? value : data.defaultValue
      }
    })
    outputData.push(outputRecord)
  }

  return outputData
}


const newAWSExtract = [
  { label: 'Customer Company Name', field: 'Customer_Company_Name', defaultValue: '', apnField: '' },
  { label: 'Industry Vertical ', field: 'Industry_Vertical', defaultValue: '', apnField: '' },
  { label: 'Industry Other', field: 'Industry_Other', defaultValue: '', apnField: '' },
  { label: 'Does opportunity belong to NatSec?', field: 'NatSec', defaultValue: '', apnField: '' },
  { label: 'Country', field: 'Country', defaultValue: '', apnField: 'country' },
  { label: 'State/Province', field: 'State_Province', defaultValue: '', apnField: '' },
  { label: 'Postal Code', field: 'Postal_Code', defaultValue: '', apnField: 'postalCode' },
  { label: 'Website', field: 'Website', defaultValue: '', apnField: 'publicReferenceUrl' },
  { label: 'Partner Primary Need from AWS', field: 'Partner_Primary_Need_from_AWS', defaultValue: '', apnField: 'partnerPrimaryNeedFromAws' },
  { label: 'Partner Project Title', field: 'Partner_Project_Title', defaultValue: '', apnField: 'partnerCrmUniqueIdentifier' },
  { label: 'Customer Business Problem', field: 'Project_Description', defaultValue: '', apnField: 'partnerProjectTitle' },
  { label: 'Solution Offered', field: 'Solution_Offered', defaultValue: '', apnField: '' },
  { label: 'Other Solution Offered', field: 'Other_Solution_Offered', defaultValue: '', apnField: '' },
  { label: 'Next Steps', field: 'Next_Steps', defaultValue: '', apnField: '' },
  { label: 'Use Case', field: 'Use_Case', defaultValue: 'Migration / Database Migration', apnField: 'useCase' },
  { label: 'Estimated AWS Monthly Recurring Revenue', field: 'Expected_Monthly_AWS_Revenue', defaultValue: '' },
  { label: 'Target Close Date', field: 'Target_Close_Date', defaultValue: '', apnField: 'targetCloseDate' },
  { label: 'Opportunity Type', field: 'Opportunity_Type', defaultValue: '', apnField: '' },
  { label: 'Delivery Model', field: 'Delivery_Model', defaultValue: 'Managed Services', apnField: '' },
  { label: 'Is Opportunity from Marketing Activity?', field: 'Opportunity_From_Marketing', defaultValue: 'No', apnField: ''},
  { label: 'Was Marketing Development Funds Used?', field: 'Marketing_Development_Funded', defaultValue: '', apnField: '' },
  { label: 'Customer DUNS', field: 'Customer_DUNS', defaultValue: '', apnField: '' },
  { label: 'Sales Activities', field: 'Sales_Activities', defaultValue: '', apnField: '' },
  { label: 'AWS Products', field: 'AWS_Products', defaultValue: '', apnField: '' },
  { label: 'Parent Opportunity ID', field: 'Parent_Opportunity_Id', defaultValue: '', apnField: '' },
  { label: 'Customer First Name', field: 'Customer_First_Name', defaultValue: '', apnField: '' },
  { label: 'Customer Last Name', field: 'Customer_Last_Name', defaultValue: '', apnField: '' },
  { label: 'Customer Title', field: 'Customer_Title', defaultValue: '', apnField: '' },
  { label: 'Customer Phone', field: 'Customer_Phone', defaultValue: '', apnField: '' },
  { label: 'Customer Email', field: 'Customer_Email', defaultValue: '', apnField: '' },
  { label: 'AWS Account ID', field: 'AWS_Account_ID', defaultValue: '', apnField: '' },
  { label: 'Additional Comments', field: 'Additional_Comments', defaultValue: '', apnField: '' },
  { label: 'Street Address', field: 'Street_Address', defaultValue: '', apnField: '' },
  { label: 'City', field: 'City', defaultValue: 'City', apnField: '' },
  // { label: 'Sub Use Case', field: 'Sub_Use_Case', defaultValue: 'None', apnField: '' },
  { label: 'Competitive Tracking', field: 'Competitive_Tracking', defaultValue: 'None', apnField: '' },
  { label: 'Other Competitors', field: 'Other_Competitors', defaultValue: '', apnField: '' },
  // { label: 'Campaign Name', field: 'Campaign_Name', defaultValue: '', apnField: '' },
  // { label: 'Contract Vehicle', field: 'Contract_Vehicle', defaultValue: '', apnField: '' },
  // { label: 'RFx/Public Tender Solicitation No.', field: 'Public_Tender_Solicitation_No', defaultValue: '', apnField: '' },
  { label: 'Marketing Campaign', field: 'Campaign_Name', defaultValue: '', apnField: ''},
  { label: 'Marketing Activity Channel', field: 'Marketing_Activity_Channel', defaultValue: '', apnField: ''},
  { label: 'Marketing Activity Use-Case', field: 'Marketing_Activity_Use_Case', defaultValue: '', apnField: ''},
  { label: 'APN Programs', field: 'APN_Programs', defaultValue: '', apnField: ''},
  // { label: 'Is this for Marketplace?', field: 'Is_this_for_Marketplace', defaultValue: '', apnField: '' },
  // { label: 'Did an AWS Account Rep for this customer support you in this opportunity?', field: 'Did_an_AWS_Account_Rep', defaultValue: '', apnField: '' },
  { label: 'Primary Sales Contact First Name', field: 'Primary_Sales_Contact_First_Name', defaultValue: '', apnField: '' },
  { label: 'Primary Sales Contact Last Name', field: 'Primary_Sales_Contact_Last_Name', defaultValue: '', apnField: '' },
  { label: 'Primary Sales Contact Phone', field: 'Primary_Sales_Contact_Phone', defaultValue: '', apnField: '' },
  { label: 'Primary Sales Contact Email', field: 'Primary_Sales_Contact_Email', defaultValue: '', apnField: '' },
  { label: 'Primary Contact Title', field: 'Primary_Contact_Title', defaultValue: '', apnField: '' },
  // { label: 'If Other please describe your needs (required if Partner Primary Need From AWS ="Other")', field: 'If_Other_please_describe_your_needs', defaultValue: '', apnField: '' },
  { label: 'Partner CRM Unique Identifier', field: 'Partner_CRM_Unique_Identifier', defaultValue: '', apnField: '' },
  { label: 'Consent to Limit Visibility  ', field: 'Consent_to_Limit_Visibility', defaultValue: '', apnField: '' }
]

export const getNewAwsExtract = (inputData, toAPN) => {
  let outputData = []
  for (let index = 0; index < inputData.length; index++) {
    let outputRecord = {}
    const record = inputData[index]
    newAWSExtract.forEach(data => {
      let label = toAPN == 1 ? data.apnField : data.label
      let value = record[data.field] == 'None' ? data.defaultValue : record[data.field]
      value = !record[data.field] ? data.defaultValue : value

      if (label) {
        outputRecord[label] = record.hasOwnProperty(data.field) == true ? value : data.defaultValue
      }

    })
    outputData.push(outputRecord)
  }

  return outputData
}


export function debounce (fn, delay) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}
